import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
const colorPalettes = {
    success: {
        base: '#2dd36f',
        shade: '#28ba62',
        tint: '#42d77d',
    },
    danger: {
        base: '#eb445a',
        shade: '#cf3c4f',
        tint: '#ed576b',
    },
    warning: {
        base: '#ffc409',
        shade: '#e0ac08',
        tint: '#ffca22',
    },
    medium: {
        base: '#92949c',
        shade: '#808289',
        tint: '#9d9fa6',
    },
    light: {
        base: '#f4f5f8',
        shade: '#d7d8da',
        tint: '#f5f6f9',
    },
};
const sizeConfig = {
    xSmall: {
        fontSize: '0.75rem',
        padding: '0.15rem 0.3rem',
        borderRadius: '0.15rem',
    },
    small: {
        fontSize: '0.8rem',
        padding: '0.25rem 0.5rem',
        borderRadius: '0.2rem',
    },
    medium: {
        fontSize: '1rem',
        padding: '0.375rem 0.75rem',
        borderRadius: '0.25rem',
    },
    large: {
        fontSize: '1.25rem',
        padding: '0.5rem 1rem',
        borderRadius: '0.3rem',
    },
};
function getFillStyle(props) {
    const { borderColor, fill, backgroundColor, color } = props;
    switch (fill) {
        case 'solid': {
            return css `
        border-color: transparent;
        background-color: ${backgroundColor.base};
        color: ${color.hover};
      `;
        }
        case 'outline': {
            return css `
        border-style: solid;
        border-color: ${backgroundColor.base};
        background-color: transparent;
        color: ${color.base};
      `;
        }
        case 'clear': {
            return css `
        border-color: transparent;
        background-color: transparent;
        color: ${color.base};
      `;
        }
        default:
            return css `
        background-color: ${backgroundColor.base};
        color: ${color.base};
        border-color: ${borderColor};
      `;
    }
}
const styles = {
    button: (props) => {
        const { size, backgroundColor, color, borderRadius } = props;
        const basic = css `
      display: flex;
      flex-direction: row;
      border-width: 1px;
      align-items: center;
    `;
        const fillStyle = getFillStyle(props);
        const colorStyle = css `
      &:not([disabled]):hover {
        background-color: ${backgroundColor.hover};
        color: ${color.hover};
      }
      &:not([disabled]):active {
        background-color: ${backgroundColor?.active || backgroundColor.hover};
        color: ${color?.active || color.hover};
      }

      &:disabled {
        opacity: 0.25;
      }
    `;
        return css([
            basic,
            sizeConfig[size],
            fillStyle,
            colorStyle,
            { borderRadius },
        ]);
    },
};
function Button(props) {
    const { onClick, size = 'small', color = { base: 'black', hover: 'white' }, backgroundColor = { base: 'white', hover: 'black', active: 'black' }, borderColor = 'transparent', fill, borderRadius, style = {}, ...restProps } = props;
    return (_jsx("button", { type: "button", onClick: onClick, css: [
            styles.button({
                size,
                backgroundColor,
                color,
                borderColor,
                fill,
                borderRadius,
            }),
            style,
        ], ...restProps, children: _jsxs("span", { style: { flex: 1, pointerEvents: 'none' }, children: [" ", props.children] }) }));
}
function ThemeButton(props) {
    const { colorTheme, ...buttonProps } = props;
    const { base, shade, tint } = colorPalettes[colorTheme];
    const { color = { base: shade, hover: 'white' }, backgroundColor = {
        base,
        hover: shade,
        active: tint,
    }, fill = 'solid', ...restProps } = buttonProps;
    return _jsx(Button, { ...{ fill, ...restProps, backgroundColor, color } });
}
Button.Done = function ButtonDone(props) {
    return _jsx(ThemeButton, { ...props, colorTheme: "success" });
};
Button.Danger = function ButtonDanger(props) {
    return _jsx(ThemeButton, { ...props, colorTheme: "danger" });
};
Button.Action = function ButtonAction(props) {
    return _jsx(ThemeButton, { ...props, colorTheme: "medium" });
};
export default Button;
